// documet.querySelector('.___video-popup_____icon').addEventListener('click', function() {
//   section.querySelector('.___video-popup_____video-frame').classList.add('visible');
//   player.playVideo();
// });
//
// Array.from(section.querySelectorAll('.___video-popup_____background, .___video-popup_____close-button')).forEach(function(element) {
//   element.addEventListener('click', function() {
//     section.querySelector('.___video-popup_____video-frame').classList.remove('visible');
//     player.pauseVideo();
//   });
// });

jQuery(document).ready(function( $ ) {
  $('.video-popup__open').click(() => {
    $('.video-popup__video-frame').fadeIn();
  });
  $('.video-popup__close-button, .video-popup__background').click(() => {
    $('.video-popup__video-frame').fadeOut(() => {
      const video = $('.video-popup__video');
      const newVideo = video.clone();
      video.parent().append(newVideo);
      video.remove();
    });
  });
  $(document).keyup(function(e) {
    if (e.keyCode !== 27) {
      return;
    }
    $('.video-popup__video-frame:visible').fadeOut(() => {
      const video = $('.video-popup__video');
      const newVideo = video.clone();
      video.parent().append(newVideo);
      video.remove();
    });
  });
});
